import Image from "next/image";
import { Box, HStack, Stack } from "@chakra-ui/react";
import { useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Text } from "@/elements";
import mangaedImg from "public/privateCloud/managed-unmanaged.png";
import TickImage from "public/shared/check-box.png";

const PointsComponent = ({
  desc,
  list,
}: {
  desc: string;
  list: { label: string; desc: string }[];
}) => {
  const TextVariant = useTextVariant();
  return (
    <Stack gap={2}>
      {desc && (
        <Text variant={TextVariant} color="text.100">
          {desc}
        </Text>
      )}
      <Stack color="text.100">
        {list.map((point, index) => (
          <HStack key={index} align="start">
            <Image
              alt={"Point"}
              src={TickImage}
              style={{ height: "auto", width: "20px", paddingTop: "4px" }}
            />{" "}
            <Box>
              <Text as="span" variant={TextVariant} fontWeight={600}>
                {point.label} - {""}
              </Text>
              <Text as="span" variant={TextVariant}>
                {point.desc}
              </Text>
            </Box>
          </HStack>
        ))}
      </Stack>
    </Stack>
  );
};

export const INTRO_CONSTANTS = {
  title: "Choosing the Right Management Model with OneMind",
  description: (
    <PointsComponent
      desc={
        "Every organization has unique needs when it comes to managing cloud infrastructure. OneMind offers three flexible service models to match your internal capabilities and strategic goals—whether you want full control, full support, or a balance of both."
      }
      list={[
        {
          label: "Managed Services",
          desc: "OneMind handles everything—monitoring, security, scaling, backups, and updates—so you don’t have to. It’s a fully hands-off experience where we ensure your infrastructure is always available, secure, and optimized.",
        },
        {
          label: "Unmanaged Services",
          desc: "You get full access to OneMind’s virtual infrastructure and platform tools, while maintaining total control over your environment. You configure, deploy, and manage everything your way.",
        },
        {
          label: "Co-managed Services",
          desc: "We partner with your internal IT or DevOps teams—sharing operational responsibilities based on your needs. You stay in the driver’s seat, and we provide the support, automation, and expertise to help you scale confidently.",
        },
      ]}
    />
  ),
  image: mangaedImg,
  imageHeight: "380px",
};
